import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

const ActivityPublicContext = createContext(undefined);
ActivityPublicContext.displayName = 'ActivityPublicContext';

export const useActivityPublicContext = () => {
  const context = useContext(ActivityPublicContext);

  // Fail fast if hook is used outside the provider
  if (!context) {
    throw new Error(
      'useActivityPublicContext must be used within the ActivityPublicContextProvider'
    );
  }

  return context;
};

export const ActivityPublicContextProvider = ({
  children,
  openSignUpModal,
  registerUrl, // `/register?activity_id=<activity_id>`, param is required for the post-onboarding redirect to the activity page
  track
}) => {
  const providerState = useMemo(
    () => ({
      openSignUpModal,
      track,
      registerUrl
    }),
    [openSignUpModal, registerUrl, track]
  );

  return (
    <ActivityPublicContext.Provider value={providerState}>
      {children}
    </ActivityPublicContext.Provider>
  );
};

ActivityPublicContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  openSignUpModal: PropTypes.func.isRequired,
  registerUrl: PropTypes.string.isRequired,
  track: PropTypes.func.isRequired
};
